document.addEventListener("DOMContentLoaded", function () {
  if (!window.gsap) return;

  gsap.registerPlugin(ScrollTrigger);

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  /*
    Premium page-load hero animation
    Add these attributes to hero elements:
    data-bj-hero
  */
  const heroItems = document.querySelectorAll("[data-bj-hero]");

  if (heroItems.length) {
    gsap.from(heroItems, {
      opacity: 0,
      y: 28,
      duration: 0.8,
      stagger: 0.12,
      ease: "power3.out"
    });
  }

  /*
    Scroll fade-up animation
    Add:
    data-bj-reveal
  */
  gsap.utils.toArray("[data-bj-reveal]").forEach((item) => {
    gsap.from(item, {
      opacity: 0,
      y: 32,
      duration: 0.75,
      ease: "power3.out",
      scrollTrigger: {
        trigger: item,
        start: "top 86%",
        once: true
      }
    });
  });

  /*
    Stagger card grids
    Add to parent:
    data-bj-stagger
  */
  gsap.utils.toArray("[data-bj-stagger]").forEach((grid) => {
    const children = grid.children;

    gsap.from(children, {
      opacity: 0,
      y: 30,
      duration: 0.7,
      stagger: 0.1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: grid,
        start: "top 84%",
        once: true
      }
    });
  });

  /*
    Premium hover effect for cards
    Add:
    data-bj-hover
  */
  gsap.utils.toArray("[data-bj-hover]").forEach((card) => {
    card.addEventListener("mouseenter", () => {
      gsap.to(card, {
        y: -5,
        duration: 0.25,
        ease: "power2.out"
      });
    });

    card.addEventListener("mouseleave", () => {
      gsap.to(card, {
        y: 0,
        duration: 0.25,
        ease: "power2.out"
      });
    });
  });

  /*
    Sticky CTA reveal
    Add:
    data-bj-sticky-cta
  */
  const stickyCTA = document.querySelector("[data-bj-sticky-cta]");

  if (stickyCTA) {
    gsap.set(stickyCTA, {
      opacity: 0,
      y: 20,
      pointerEvents: "none"
    });

    ScrollTrigger.create({
      trigger: "body",
      start: "top -450px",
      onEnter: () => {
        gsap.to(stickyCTA, {
          opacity: 1,
          y: 0,
          pointerEvents: "auto",
          duration: 0.3,
          ease: "power2.out"
        });
      },
      onLeaveBack: () => {
        gsap.to(stickyCTA, {
          opacity: 0,
          y: 20,
          pointerEvents: "none",
          duration: 0.3,
          ease: "power2.out"
        });
      }
    });
  }
});